<template>
    <div class="container">
        <HomeHeader />
        <ReportHeader>
            <div class="show_date">
                <ShowYear />
                <ShowMonth style="margin-left: 57px" />
            </div>
        </ReportHeader>
        <main>
            <div class="main_container">
                <h1>应急处理建议</h1>
                <el-table :data="tableData" stripe :header-cell-style="{ background: '#E6E6E6', color: '#333' }">
                    <el-table-column type="index" label="序号" width="50" align="center" />
                    <el-table-column prop="type" label="舆情类型" />
                    <el-table-column prop="value" label="应急处置建议" min-width="200">
                        <template #default="scope">
                            <div v-html="scope.row.value"></div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </main>
    </div>
</template>

<script setup>
import { ref } from "vue";
import HomeHeader from "@/components/common/HomeHeader.vue";
import ReportHeader from "@/components/customer-week-report/pc/ReportHeader.vue";
import ShowYear from "@/components/customer-week-report/pc/ShowYear.vue";
import ShowMonth from "@/components/customer-week-report/pc/ShowMonth.vue";

const tableData = [
    {
        type: "涉疆涉贸易合规",
        value: `1.与网信办沟通，删除原稿。<br/>2.面监测舆情动态，精准分析。<br/>3.咨询风控或第三方公司，进一步研判。`,
    },
    {
        type: "财经类",
        value: `1.及时应对，抢占先机。<br/>2.借助第三方力量，强化正面声音。<br/>3.主动传播正面信息，重塑形象。<br/>4.多元化公关渠道，灵活应对。`,
    },
    {
        type: "《战略合作协议》《合作框架协议》等",
        value: `1.提前与对方沟通，明确提出不提及特变电工。<br/>2.直接删稿。<br/>3.协议内容提前报审。`,
    },
    {
        type: "市场营销活动、客户拜访等",
        value: `1.严格审核对外汇报材料。<br/>2.加强对供应商、经销商等第三方的培训，规范使用公司LOGO。<br/>3.公司统一提供对外汇报材料。`,
    },
    {
        type: "外部协会组织、活动上的发言",
        value: `1.各类对外发言也属于外宣，容易出问题，要一并纳入管理要求。<br/>2.参加对外技术推介、论坛、展会、座谈会等公开场合，未经审批同意不得对外介绍经验。<br/>3.确需发言的，发言内容需提前报审。<br/>4.各经营单位汇报和发言内容，审批同意后方可执行。`,
    },
    {
        type: "供应链、政府平台公示",
        value: `1.公司及各单位供应链网站、公众号等平台发布的内容，要履行审核流程。<br/>2.政府招采平台，涉及公司简介的，要使用脱敏版的公司简介。<br/>3.客户招采平台，涉及公司简介的，要使用脱敏版的公司简介。`,
    },
    {
        type: "人力招聘",
        value: `1.要求公司及各单位人力资源部门加强对招聘信息发布的规范审核。<br/>2.公司简介、公司经营数据、排名等内容，务必提前与总裁办、证券事务部、风控合规部确认，并履行审批流程。<br/>3.加强对人力招聘平台的合规运维管理，发布的内容要明确责任主体，规避合规风险。`,
    },
    {
        type: "员工个人发布或转发",
        value: `1.严格管理员工在直播平台、小红书、微信朋友圈、视频号、抖音、快手、微博、论坛等社交平台的发布内容，员工自己发布的内容不得涉及企业；涉及企业的，要进行审批。<br/>2.公司TBe+新闻资讯、开讲了的内容，仅限于内部员工阅读，不得截图转发到朋友圈等外部平台。`,
    },
    {
        type: "展厅展会",
        value: `1.严格管理展厅参观。各类外部接待，在参观各单位展厅、车间路线时，提醒不拍摄密。<br/>2.严格审核展会展示内容，特别是涉及公司简介、经营数据、排名等内容。`,
    },
    {
        type: "内宣",
        value: `1.联合风控审核各单位内宣平台刊发内容，确保内容安全可控。<br/>2.要做好本单位各类图片、文字、视频等出口管控，做好台账登记。<br/>3.加强合作的广告公司的保密要求管控，专项工作专项对接，资料要专项保存、使用、销毁，确保公司文字材料和图片资料不流出。`,
    },
];
</script>

<style lang="scss" scoped>
.container {
    background-color: #e6e6e6;
    min-height: 100vh;
    padding-top: var(--home-header-height);

    .show_date {
        border-top: 1px solid var(--week-primary-color);
        position: absolute;
        top: 60px;
        right: 44px;
        padding-top: 30px;
        padding-right: 100px;
        padding-left: 10px;
        display: flex;
        align-items: center;
    }

    .small_logo {
        position: absolute;
        top: 87px;
        right: 52px;
    }

    main {
        width: 100%;
        .main_container {
            width: 1176px;
            margin: 0 auto;
            min-height: calc(100vh - var(--week-pc-header-height));
            background: rgba(243, 243, 243, 1);
            box-shadow: 0 0 20px #ccc;
            padding: 50px 110px;
            padding-bottom: 76px;
        }
        h1 {
            text-align: center;
            font-size: 36px;
            font-weight: 400;
            padding-bottom: 50px;
        }
        .el-table {
            width: 100%;
        }
    }
}
</style>
